import { CancelScheduledPayment } from '../contracts';
import axios from 'axios';
import { createAxiosConfig } from '../apiHelpers';
import LogCannon from '@ace-clublabs/log-cannon';
import { ICancelScheduledPaymentRequest } from '@lib/types';
import { AxiosError } from 'axios';
import StatusCode from 'status-code-enum';

export const CancelScheduledPaymentApi =
  (endpoint: string): CancelScheduledPayment =>
  async (request: ICancelScheduledPaymentRequest) => {
    try {
      const config = { ...createAxiosConfig(endpoint) };
      const response = await axios.post(endpoint, request, config);

      LogCannon.blast('Cancel scheduled payment success');
      return Promise.resolve(response.data);
    } catch (e: any | AxiosError) {
      const errorResponse = e?.response?.data?.error;
      LogCannon.blast('Cancel scheduled payment error', errorResponse);
      return Promise.resolve({
        status: 'error',
        error: {
          code: e?.response?.status || StatusCode.ServerErrorInternal,
          message: 'Cancel scheduled payment failed',
          ...errorResponse,
        },
      });
    }
  };
